export const APP_VERSION = '20261104-e79f59a';